import { render, staticRenderFns } from "./PriceSection.vue?vue&type=template&id=17b82ed8&scoped=true"
import script from "./PriceSection.vue?vue&type=script&setup=true&lang=js"
export * from "./PriceSection.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PriceSection.vue?vue&type=style&index=0&id=17b82ed8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b82ed8",
  null
  
)

export default component.exports